module.exports = __webpack_public_path__ + "img/tech-teach.9c1c91c2.png";